import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { Application } from '../../../../model/Application';
import { HttpResponse } from '../../../../model/HttpResponse';
import { Modalidad } from '../../../../model/Modalidad';
import { Nivel } from '../../../../model/Nivel';
import { Role } from '../../../../model/Role';
import { AcademyAdministratorOperation } from '../../../../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../../../../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../../../../model/administrator/AdministratorEntity';
import { Product } from '../../../../model/administrator/ProductAndServices/Product';
import { ApplicationType } from '../../../../model/enum/ApplicationType';
import { GenderType } from '../../../../model/genderType';
import { IdType } from '../../../../model/idType';
import { AdministrationService } from '../../../../services/administration.service';
import { ApplicationService } from '../../../../services/application.service';
import { LoadingService } from '../../../../services/loading.service';
import { PageHeaderComponent } from '../../../shared/page-header/page-header.component';
import { CrudTableComponent } from '../../../shared/tables/crud-table/crud-table.component';

@Component({
  selector: 'app-solicitud-form',
  standalone: true,
  imports: [ConfirmDialogModule,
    InputTextareaModule,
    CalendarModule,
    InputMaskModule,
    SelectButtonModule,
    InputSwitchModule,
    InputTextModule,
    PageHeaderComponent,
    CrudTableComponent,
    CommonModule,
    DialogModule,
    ReactiveFormsModule,
    MultiSelectModule,
    InputNumberModule,
    FloatLabelModule,
    DropdownModule 
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './solicitud-form.component.html',
  styleUrl: './solicitud-form.component.scss',
})
export class SolicitudFormComponent implements OnInit {
  validateForm!: FormGroup;
  showForm: boolean = false;
  dialogHeader: string = '';


  @Input()
  application!: Application;

  @Output()
  goToBackEvent: EventEmitter<boolean> = new EventEmitter();

  applicationTypeOptions: any[] = [
    { label: 'Nueva Vinculación', value: ApplicationType.NEW },
    { label: 'Renovación de Vinculación', value: ApplicationType.RENEWAL },
  ];

  idTypes = [
    { name: 'Registro Civil', value: IdType.REGISTRO_CIVIL },
    { name: 'Tarjeta de identidad', value: IdType.TARJETA_IDENTIDAD },
    { name: 'Cédula', value: IdType.CEDULA },
    { name: 'Pasaporte', value: IdType.PASAPORTE },
    { name: 'Cédula de Extranjería', value: IdType.CEDULA_EXTRANGERIA },
    {
      name: 'Documento de Identidad Extranjero',
      value: IdType.IDENTIDAD_EXTRANGERA,
    },
  ];

  modalidades = [
    { name: 'Artístico', value: Modalidad.ARTISTICO },
    { name: 'Carreras', value: Modalidad.CARRERAS },
    { name: 'Hockey', value: Modalidad.HOCKEY },
    { name: 'Skateboarding', value: Modalidad.SKATEBOARDING },
    { name: 'Inline Downhill', value: Modalidad.INLINE_DOWNHILL },
    { name: 'Inline Freestyle', value: Modalidad.INLINE_FREESTYLE },
  ];

  roles = [
    { name: 'Deportista', value: Role.DEPORTISTA },
    { name: 'Entrenador', value: Role.ENTRENADOR },
    { name: 'Técnico', value: Role.TECNICO },
    { name: 'Delegado', value: Role.DELEGADO },
  ];

  genderTypes = [
    { name: 'Femenino', value: GenderType.FEMENINO },
    { name: 'Masculino', value: GenderType.MASCULINO },
    // { name: 'No Binario', value: GenderType.NO_BINARIO },
  ];

  levelTypes = [
    { name: 'Liga', value: Nivel.LIGA },
    { name: 'Novato', value: Nivel.NOVATO }
  ];

  productos:Product[] = [];
  paymentItems:any[] = [];
  constructor(
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private applicationService: ApplicationService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private administrationService: AdministrationService
  ) {}
  ngOnInit(): void {

  this.getProducts();
  }

  getForm() {
    this.validateForm = this.fb.group({
      applicantIdType: [
        this.application.applicant.idType,
        [Validators.required],
      ],
      applicantIdNumber: [
        this.application.applicant.idNumber,
        [Validators.required],
      ],
      applicantName: [this.application.applicant.name, [Validators.required]],
      applicantLastName: [
        this.application.applicant.lastName,
        [Validators.required],
      ],
      applicantEmail: [
        this.application.applicant.contactInformation.email,
        [Validators.required, Validators.email],
      ],
      applicantPhone: [
        this.application.applicant.contactInformation.mobile,
        [Validators.required],
      ],
      applicantbirthDay: [
        this.application.applicant.birthDay,
        [Validators.required],
      ],
      applicantGender: [
        this.application.applicant.gender,
        [Validators.required],
      ],
      applicantInsurance: [
        this.application.applicant.assistanceInformation.insurance,
        [Validators.required],
      ],
      applicationLevel: [this.application.nivel, [Validators.required]],
      applicationRole: [this.application.rol, [Validators.required]],
      applicationModality: [this.application.modalidad, [Validators.required]],
      applicationType: [this.application.type, [Validators.required]],
      applicationPaymentItems:[this.application.payment?.paymentItems, [Validators.required]]
    });
    this.dialogHeader = `Editar la solicitud de ${this.application.applicant.name} ${this.application.applicant.lastName}`;
    this.showForm = true;
  }

  initUpdateApplication(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `¿Confirma que desea actualizar la solicitud de ${this.application.applicant.name} ${this.application.applicant.lastName}?`,
      header: 'Confirmar Actualización',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        this.saveApplication();
      },
    });
  }

  saveApplication() {
    if (this.validateForm.valid) {
      this.loadingService.showLoading();
      this.buildApplication();
      this.applicationService
        .updateApplication(this.application)
        .subscribe((res: HttpResponse) => {
          this.loadingService.hideLoading();
          this.messageService.add({
            severity: 'success',
            summary: 'Solicitud Actualizada',
            detail: 'La solicitud ha sido actualizada correctamente',
          });
          this.goToBackEvent.emit(true);
        });
    }
  }

  buildApplication() {
    if (this.validateForm.valid) {
      this.application.applicant.idType =
        this.validateForm.get('applicantIdType')?.value;
      this.application.applicant.idNumber =
        this.validateForm.get('applicantIdNumber')?.value;
      this.application.applicant.name =
        this.validateForm.get('applicantName')?.value;
      this.application.applicant.lastName =
        this.validateForm.get('applicantLastName')?.value;
      this.application.applicant.contactInformation.email =
        this.validateForm.get('applicantEmail')?.value;
      this.application.applicant.contactInformation.mobile =
        this.validateForm.get('applicantPhone')?.value;
      this.application.applicant.birthDay =
        this.validateForm.get('applicantbirthDay')?.value;
      this.application.applicant.gender =
        this.validateForm.get('applicantGender')?.value;
      this.application.applicant.assistanceInformation.insurance =
        this.validateForm.get('applicantInsurance')?.value;
      this.application.nivel = this.validateForm.get('applicationLevel')?.value;
      this.application.rol = this.validateForm.get('applicationRole')?.value;
      this.application.modalidad = this.validateForm.get(
        'applicationModality'
      )?.value;
      this.application.type = this.validateForm.get('applicationType')?.value;
      this.application.payment!.paymentItems = this.validateForm.get('applicationPaymentItems')?.value;
    }
  }

  closeDialog(){
    this.showForm = false;
    this.goToBackEvent.emit(true);
  }


  async getProducts(): Promise<void> {
    const groupData = await this.getEntity(
      AcademyAdministratorType.PRODUCTS_SERVICES,
      true,
      'isActive'
    );
    this.productos = groupData as Product[];
    this.getProductMap();

  
  }


  async getEntity(
    academyAdministratorType: AcademyAdministratorType,
    value: any,
    property?: string
  ): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
      this.loadingService.showLoading();

      let data: any[] = [];
      let entity: AdministratorEntity = {
        operation: AcademyAdministratorOperation.SELECT,
        payload: {
          options: {
            conditionals: [
              {
                conditionalConnector: null,
                logicOperator: '=',
                evaluatedProperty: property || 'id',
                parameterName: '@Option1',
                parameterValue: value,
              },
            ],
          },
        },
        type: academyAdministratorType,
      };
      try {
        this.administrationService
          .sendRequest(entity)
          .subscribe((res: HttpResponse) => {
            if (res.response.length > 0) {
              data = res.response as any[];
            }
            resolve(data);
            this.loadingService.hideLoading();
          });
      } catch (error) {
        reject(error);
      }
    });
  }

  getProductMap(){
      this.paymentItems = this.productos.map((product:Product) => {
        return {
          amount:product.price,
          product:product.name,
          descripcion:product.description,
          tipo:product.type,
          valorUnitario:product.price,
          valorTotal:product.hasTax ? product.price + (product.price * product.taxValue) : product.price,
          porcentajeIva:product.taxValue,
        }

      });      
      this.getForm();
  }

  onChangeApplicationType(event:any){
    this.validateForm.get('applicationPaymentItems')?.setValue([]);
  }
}
